import { apiClient } from './client';

export interface APIAchievement {
  achievementId: string;
  name: string;
  description: string;
  icon: string;
  rarity: 'common' | 'rare' | 'epic' | 'legendary';
  unlockedAt: string;
}

export interface GetAchievementsResponse {
  achievements: APIAchievement[];
  total: number;
}

export interface UnlockAchievementRequest {
  achievementId: string;
}

export const achievementsApi = {
  async getAchievements(userId: string): Promise<GetAchievementsResponse> {
    return apiClient.get(`/users/${userId}/achievements`);
  },

  async unlockAchievement(userId: string, achievementId: string): Promise<APIAchievement> {
    return apiClient.post(`/users/${userId}/achievements`, { achievementId });
  },
};
